module.exports = __webpack_public_path__ + "img/devoluciones.f38618a6.png";